import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { FrameRedirectComponent } from './frame-redirect/frame-redirect.component';

export const routes: Routes = [
  { path: '', component: LoginComponent }, // default route of the module
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'frame-redirect', component: FrameRedirectComponent },
  { path: 'frame-redirect#:id_token', component: FrameRedirectComponent },
];
  
export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes); 
